import { Auth0LockPasswordless } from 'auth0-lock';
import history from './History';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE, AUTH0_REDIRECT_URL } from '../Constants';

const passwordlessOptions = {
  autoclose: true,
  autofocus: true,
  closable: false,
  allowedConnections: ['sms'],
  passwordlessMethod: 'code',
  auth: {
    redirectUrl: AUTH0_REDIRECT_URL,
    audience: AUTH0_AUDIENCE,
    responseType: 'token id_token',
    params: {
      scope: 'openid profile'
    }
  },
  languageDictionary: {
    title: 'Confirm your phone number',
    passwordlessSMSInstructions: "This is so you can receive requests from customers. ",
    submitLabel: 'Confirm Phone Number'
  },
  theme: {
    logo: '',
    primaryColor: '#363636'
  },
  configurationBaseUrl: 'https://cdn.au.auth0.com',
  mustAcceptTerms: false
}
class Auth {
  constructor() {
    this.lock = new Auth0LockPasswordless(
      AUTH0_CLIENT_ID,
      AUTH0_DOMAIN,
      passwordlessOptions
    );
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.login = this.login.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.getIdToken = this.getIdToken.bind(this);
    this.setSession = this.setSession.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);

    this.handleAuthentication();

    // binds functions to keep this context\
  }

  login() {
    // Call the show method to display the widget.
    this.lock.show();
  }

  handleAuthentication() {
    // Add a callback for Lock's `authenticated` event
    this.lock.on('authenticated', this.setSession);
    // Add a callback for Lock's `authorization_error` event
    this.lock.on('authorization_error', (err) => {
      console.log(err);
      alert(`Error: ${err.error}. Check the console for further details.`);
      history.push('/')

    });
  }
  getProfile() {
    return this.profile;
  }

  getIdToken() {
    return this.idToken;
  }

  setSession(authResult) {
    if (authResult && authResult.accessToken && authResult.idToken) {
      this.profile = authResult.idTokenPayload;
      this.idToken = authResult.idToken;      // Set the time that the access token will expire at
      let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
      localStorage.setItem('access_token', authResult.accessToken);
      localStorage.setItem('id_token', authResult.idToken);
      localStorage.setItem('expires_at', expiresAt);
      localStorage.setItem("profile", JSON.stringify(authResult.idTokenPayload));

      // navigate to the home route
      let redirectPath = '/';
      if (localStorage.getItem('pathRequested')) {
        redirectPath = localStorage.getItem('pathRequested');
      }
      history.push(redirectPath);
    }
  }
  getProfile = () => {
    let profile = localStorage.getItem('profile');
    return profile;
  }

  getIdToken = () => {
    let idToken = localStorage.getItem('id_token');
    return idToken;
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // navigate to the home route
    history.push('/')
  }

  isAuthenticated() {
    // Check whether the current time is past the 
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

}

const auth0client = new Auth();

export { auth0client }